import api from '../api';
import * as actions from '../../actions';
import { store } from '../../index';
import React from 'react';
import moment from 'moment';

import { sortBy } from 'lodash';

import * as doors from './doors';

const ERROR_TIMEOUT = 10000;

export const postToLog = (data) => {
  return api
    .post('https://gk260eluz1.execute-api.us-east-2.amazonaws.com/api/', data)
    .then((res) => {
      console.error(res.data);
    })
    .catch((err) => {
      console.error('LOGGING API ERROR. Original Error not Logged', err);
    });
};

export const getActiveCampaigns = () => {
  return api.get('/campaigns/').then((res) => {
    store.dispatch(actions.setCampaignList(res.data));
  });
};

export const getFocusedCampaign = () => {
  //based on the cookie we pulled from the other site. ON TRANSITION, this will have to be set in state
  store.dispatch(actions.setFocusedCampaign(1));
};

export const login = (data) => {
  store.dispatch(actions.setAccessToken(null));
  store.dispatch(actions.setRefreshToken(null));
  store.dispatch(actions.setLoginFailure(null));
  return api
    .post('/login/', data)
    .then((res) => {
      const { access, refresh, mfa } = res.data;
      store.dispatch(actions.setAccessToken(access));
      store.dispatch(actions.setRefreshToken(refresh));
      return res.data;
    })
    .catch((err) => {
      let err_msg;
      console.log('ERROR', err.config, err.request, err.code);

      if (err.response) {
        const { status } = err.response;
        if (('' + status).split('')[0] == '4') {
          if (err.response.data.error) {
            err_msg = err.response.data.error;
          } else {
            err_msg = 'That username and password combination, or your mfa code, was invalid.';
          }
        } else if (('' + status).split('')[0] == '5') {
          err_msg = "Oops! There's been a server error. Try again in a minute.";
        } else {
          err_msg = "Looks like something's broken. That's all we know.";
        }
      } else {
        err_msg = 'Looks like something went wrong and we were unable to reach the server.';
      }
      store.dispatch(actions.setLoginFailure(err_msg));
    });
};

export const setFocusedCampaign = (id) => {
  return api
    .get('/set-campaign/?campaign=' + id)
    .then((res) => {
      store.dispatch(actions.setFocusedCampaign(res.data));
    })
    .then(() => {
      //check the offices reducer to see if it's already there (don't trigger on refresh)
      //otherwise, fire
      const state = store.getState();
      const offices = state.offices.data;
      if (!offices.length || offices[0].campaign.id !== id) {
        return pullCampaignOffices();
      }
    });
};

export const updateCampaignAggregates = (start, end) => {
  let params = {};
  if (start && end) params = { start, end };

  store.dispatch(actions.setAggregatesLoading(true));
  store.dispatch(actions.setAggregatesError(false));
  return api
    .get('/campaign-aggregates/', params)
    .then((res) => {
      store.dispatch(actions.updateCampaignAggData(res.data));
      store.dispatch(actions.setAggregatesLoading(false));
    })
    .catch((err) => {
      store.dispatch(actions.setAggregatesLoading(false));
      store.dispatch(actions.setAggregatesError(true));
    });
};

export const pullCanvasserStatuses = (config = {}) => {
  store.dispatch(actions.setTrackerMapError(false));
  store.dispatch(actions.setTrackerMapLoading(true));

  return api
    .get('canvasser-status/', { ...config })
    .then((res) => {
      store.dispatch(actions.setTrackerMapLoading(false));
      console.log('STATUS FIRST CHECK', res);
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setTrackerMapLoading(false));
      store.dispatch(actions.setTrackerMapError(true));
      setTimeout(() => store.dispatch(actions.setTrackerMapError(false)), ERROR_TIMEOUT);
    });
};

// DEFUNCT. ALL THIS DOES AT THE CAMPAIGN LEVEL IS PULL OFFICES. WE NOW USE PROPS AND PULL CAMPAIGN OFFICES
export const pullCampaignMap = (campaign_id, start, end) => {
  store.dispatch(actions.setTrackerMapError(false));
  store.dispatch(actions.setTrackerMapLoading(true));

  return api
    .get('canvasser-status/', { campaign: campaign_id })
    .then((res) => {
      store.dispatch(actions.setTrackerMapLoading(false));
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setTrackerMapLoading(false));
      store.dispatch(actions.setTrackerMapError(true));
      setTimeout(() => store.dispatch(actions.setTrackerMapError(false)), ERROR_TIMEOUT);
    });
};

//the following calls all depend on session key to get campaign in django
export const pullCampaignSites = (params = {}) => {
  store.dispatch(actions.setCampaignSitesLoading(true));
  store.dispatch(actions.setCampaignSitesError(false));

  return api
    .get('sites/', params)
    .then((res) => {
      store.dispatch(actions.setCampaignSitesLoading(false));
      store.dispatch(actions.setCampaignSites(sortBy(res.data, (d) => d.name)));
      return res;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setCampaignSitesError(true));
      setTimeout(() => store.dispatch(actions.setCampaignSitesError(false)), ERROR_TIMEOUT);
    });
};

export const updateOrCreateSite = (data) => {
  store.dispatch(actions.setCampaignSitesLoading(true));
  store.dispatch(actions.setCampaignSitesError(false));

  if (Object.keys(data).includes('id') && data.id) {
    return api
      .patch(`sites/${data.id}/`, data)
      .then((res) => {
        store.dispatch(actions.updateSite(res.data));
        store.dispatch(actions.setCampaignSitesLoading(false));
        return res.data;
      })
      .catch((err) => {
        console.log(err);
        store.dispatch(actions.setCampaignSitesError(true));
        setTimeout(() => store.dispatch(actions.setCampaignSitesError(false)), ERROR_TIMEOUT);
      });
  } else {
    return api.post('sites/', data).then((res) => {
      store.dispatch(actions.insertSite(res.data));
      store.dispatch(actions.setCampaignSitesLoading(false));
      return res.data;
    });
  }
};

//CAMPAIGNS

export const pullCampaigns = () => {
  store.dispatch(actions.setCampaignsLoading(true));
  store.dispatch(actions.setCampaignsError(false));

  return api
    .get('campaigns/', {})
    .then((res) => {
      store.dispatch(actions.setCampaignsLoading(false));
      store.dispatch(actions.setCampaigns(res.data));
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setCampaignsError(true));
      setTimeout(() => store.dispatch(actions.setCampaignsError(true)), ERROR_TIMEOUT);
    });
};

export const updateOrCreateCampaign = (data) => {
  store.dispatch(actions.setCampaignsLoading(true));
  store.dispatch(actions.setCampaignsError(false));

  if (Object.keys(data).includes('id')) {
    return api
      .patch(`campaigns/${data.id}/`, data)
      .then((res) => {
        store.dispatch(actions.updateCampaign(res.data));
        store.dispatch(actions.setCampaignsLoading(false));
      })
      .catch((err) => {
        console.log(err);
        store.dispatch(actions.setCampaignsError(true));
        setTimeout(() => store.dispatch(actions.setCampaignsError(false)), ERROR_TIMEOUT);
      });
  } else {
    return api.post('campaigns/', data).then((res) => {
      store.dispatch(actions.insertCampaign(res.data));
      store.dispatch(actions.setCampaignsLoading(false));
    });
  }
};

//SITE CANVASS

export const pullCampaignSiteCanvasses = () => {
  store.dispatch(actions.setCampaignSiteCanvassesLoading(true));
  store.dispatch(actions.setCampaignSiteCanvassesError(false));

  return api
    .get('sitecanvasses/', {})
    .then((res) => {
      store.dispatch(actions.setCampaignSiteCanvassesLoading(false));
      store.dispatch(actions.setCampaignSiteCanvasses(res.data));
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setCampaignSiteCanvassesError(true));
      setTimeout(() => store.dispatch(actions.setCampaignSiteCanvassesError(false)), ERROR_TIMEOUT);
    });
};

export const updateOrCreateSiteCanvass = (data) => {
  store.dispatch(actions.setCampaignSiteCanvassesLoading(true));
  store.dispatch(actions.setCampaignSiteCanvassesError(false));

  if (Object.keys(data).includes('id')) {
    return api
      .patch(`sitecanvasses/${data.id}/`, data)
      .then((res) => {
        store.dispatch(actions.updateSiteCanvass(res.data));
        store.dispatch(actions.setCampaignSiteCanvassesLoading(false));
      })
      .catch((err) => {
        console.log(err);
        store.dispatch(actions.setCampaignSiteCanvassesError(true));
        setTimeout(
          () => store.dispatch(actions.setCampaignSiteCanvassesError(false)),
          ERROR_TIMEOUT
        );
      });
  } else {
    return api.post('sitecanvasses/', data).then((res) => {
      store.dispatch(actions.insertSiteCanvass(res.data));
      store.dispatch(actions.setCampaignSiteCanvassesLoading(false));
    });
  }
};

//currently used only for siteRoutes page, to verify that assigned site route is in the correct campaign.
//that's because we pull the campaign from the URL parameter, and it's possible that someone goes direclty
//to the url without changing the campaing. This would result in a data mismatch.
export const matchSiteCanvassToCampaign = (sitecanvass_id) => {
  return api.get(`sitecanvasses/${sitecanvass_id}/`, { all: 1 }).then((res) => {
    const data = res.data;
    const state = store.getState();
    if (data.campaign !== state.session.focusedCampaign.id) {
      store.dispatch(actions.setFocusedCampaign(data.campaign));
    }
    return data;
  });
};

//CANVASSERS

export const pullCampaignCanvassers = (params) => {
  store.dispatch(actions.setCampaignCanvassersLoading(true));
  store.dispatch(actions.setCampaignCanvassersError(false));

  return api
    .get('canvassers/', params)
    .then((res) => {
      store.dispatch(actions.setCampaignCanvassersLoading(false));
      store.dispatch(actions.setCampaignCanvassers(res.data));
      return res.data;
    })
    .catch((err) => {
      store.dispatch(actions.setCampaignCanvassersLoading(false));
      store.dispatch(actions.setCampaignCanvassersError(true));
      setTimeout(() => store.dispatch(actions.setCampaignCanvassersError(false)), ERROR_TIMEOUT);
      return Promise.reject(err);
    });
};

export const updateOrCreateCanvasser = (data) => {
  store.dispatch(actions.setCampaignCanvassersLoading(true));
  store.dispatch(actions.setCampaignCanvassersError(false));

  if (Object.keys(data).includes('id') && data.id !== null) {
    return api
      .patch(`canvassers/${data.id}/`, data)
      .then((res) => {
        store.dispatch(actions.updateCanvasser(res.data));
        store.dispatch(actions.setCampaignCanvassersLoading(false));
      })
      .catch((err) => {
        store.dispatch(actions.setCampaignCanvassersLoading(false));
        store.dispatch(actions.setCampaignCanvassersError(true));
        setTimeout(() => store.dispatch(actions.setCampaignCanvassersError(false)), ERROR_TIMEOUT);
      });
  } else {
    return api.post('canvassers/', data).then((res) => {
      store.dispatch(actions.insertCanvasser(res.data));
      store.dispatch(actions.setCampaignCanvassersLoading(false));
    });
    //NO CATCH SO WE CAN HANDLE IN SCREEN
  }
};

// CANVASSER EVENTS

export const pullCanvasserEvents = (param_obj) => {
  store.dispatch(actions.setReportCanvasserEventsLoading(true));
  store.dispatch(actions.setReportCanvasserEventsError(false));

  return api
    .get('canvasser-events/', param_obj)
    .then((res) => {
      let data = res.data.filter((d) => d);
      store.dispatch(actions.setReportCanvasserEventsLoading(false));
      store.dispatch(actions.setReportCanvasserEvents(data));
      return data;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setReportCanvasserEventsError(true));
      setTimeout(() => store.dispatch(actions.setReportCanvasserEventsError(false)), ERROR_TIMEOUT);
    });
};

export const pullCanvasserBreadcrumbs = (param_obj) => {
  // params require: date YYYY-MM-DD, canvasser_id, max_time
  store.dispatch(actions.setReportCanvasserEventsLoading(true));
  store.dispatch(actions.setReportCanvasserEventsError(false));

  return api
    .get('canvasser-breadcrumbs/', param_obj)
    .then((res) => {
      let data = res.data.filter((d) => d);
      store.dispatch(actions.setReportCanvasserEventsLoading(false));
      store.dispatch(actions.setReportCanvasserBreadcrumbs(data));
      return data;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setReportCanvasserEventsError(true));
      setTimeout(() => store.dispatch(actions.setReportCanvasserEventsError(false)), ERROR_TIMEOUT);
    });
};

// CREWS
export const pullCrews = (data) => {
  store.dispatch(actions.setCrewsLoading(true));
  store.dispatch(actions.setCrewsError(false));

  // expects sitecanvass_id and a date
  return api
    .get('crews/', data)
    .then((res) => {
      store.dispatch(actions.setCrews(res.data));
      store.dispatch(actions.setCrewsLoading(false));
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setCrewsError(true));
      setTimeout(() => store.dispatch(actions.setCrewsError(false)), ERROR_TIMEOUT);
      return Promise.reject(err);
    });
};

export const createCrew = (data) => {
  store.dispatch(actions.setCrewsLoading(true));
  store.dispatch(actions.setCrewsError(false));
  return api
    .post('crews/', data)
    .then((res) => {
      store.dispatch(actions.insertCrew(res.data));
      store.dispatch(actions.setCrewsLoading(false));
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setCrewsError(true));
      setTimeout(() => store.dispatch(actions.setCrewsError(false)), ERROR_TIMEOUT);
    });
};

export const deleteCrew = (id) => {
  store.dispatch(actions.setCrewsLoading(true));
  store.dispatch(actions.setCrewsError(false));
  return api
    .delete(`crews/${id}/`)
    .then(() => {
      store.dispatch(actions.removeCrew(id));
      store.dispatch(actions.setCrewsLoading(false));
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setCrewsError(true));
      setTimeout(() => store.dispatch(actions.setCrewsError(false)), ERROR_TIMEOUT);
    });
};

export const updateCrew = (id, data) => {
  store.dispatch(actions.setCrewsLoading(true));
  store.dispatch(actions.setCrewsError(false));

  return api
    .patch(`crews/${id}/`, { ...data })
    .then((res) => {
      store.dispatch(actions.updateCrew(res.data));
      store.dispatch(actions.setCrewsLoading(false));
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setCrewsError(true));
      setTimeout(() => store.dispatch(actions.setCrewsError(false)), ERROR_TIMEOUT);
    });
};

//CREW CANVASSER
export const deleteCrewCanvasser = (id) => {
  return api.delete(`crewcanvassers/${id}/`);
};

export const createCrewCanvasser = (data) => {
  return api.post('crewcanvassers/', data).then((res) => res.data);
};

export const updateCrewCanvasser = (data) => {
  return api.patch(`crewcanvassers/${data.id}/`, data).then((res) => res.data);
};

// SHIFT CANVASSER
export const updateShiftCanvasser = (data) => {
  // expects shift, canvasser, and most important crew
  return api
    .patch(`shiftcanvassers/${data.canvasser}/`, data)
    .then((res) => res.data)
    .catch((err) => err);
};

export const createShiftCanvasser = (data) => {
  return api
    .post('shiftcanvassers/', data)
    .then((res) => res.data)
    .catch((err) => err);
};

//OFFICES
export const pullCampaignOffices = () => {
  store.dispatch(actions.setCampaignOfficesLoading(true));
  store.dispatch(actions.setCampaignOfficesError(false));

  return api
    .get('offices/')
    .then((res) => {
      store.dispatch(actions.setCampaignOfficesLoading(false));
      store.dispatch(actions.setCampaignOffices(res.data));
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setCampaignOfficesError(true));
      setTimeout(() => store.dispatch(actions.setCampaignOfficesError(false)), ERROR_TIMEOUT);
    });
};

export const updateOrCreateOffice = (data) => {
  store.dispatch(actions.setCampaignOfficesLoading(true));
  store.dispatch(actions.setCampaignOfficesError(false));

  if (Object.keys(data).includes('id')) {
    return api
      .patch(`offices/${data.id}/`, data)
      .then((res) => {
        store.dispatch(actions.updateOffice(res.data));
        store.dispatch(actions.setCampaignOfficesLoading(false));
      })
      .catch((err) => {
        console.log(err);
        store.dispatch(actions.setCampaignOfficesError(true));
        setTimeout(() => store.dispatch(actions.setCampaignOfficesError(false)), ERROR_TIMEOUT);
      });
  } else {
    return api.post('offices/', data).then((res) => {
      store.dispatch(actions.insertOffice(res.data));
      store.dispatch(actions.setCampaignOfficesLoading(false));
    });
  }
};

//USERS

export const pullUsers = (params = {}) => {
  store.dispatch(actions.setUsersLoading(true));
  store.dispatch(actions.setUsersError(false));

  return api
    .get('users/', { ...params })
    .then((res) => {
      store.dispatch(actions.setUsersLoading(false));
      if (params.deactivated) {
        store.dispatch(actions.setInactiveUsers(res.data));
      } else {
        store.dispatch(actions.setUsers(res.data));
      }
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setUsersError(true));
      setTimeout(() => store.dispatch(actions.setUsersError(true)), ERROR_TIMEOUT);
    });
};

export const updateOrCreateUser = (data) => {
  store.dispatch(actions.setUsersLoading(true));
  store.dispatch(actions.setUsersError(false));

  if (Object.keys(data).includes('id')) {
    return api
      .patch(`users/${data.id}/`, data)
      .then((res) => {
        store.dispatch(actions.updateUser(res.data));
        store.dispatch(actions.setUsersLoading(false));
        return res.data;
      })
      .catch((err) => {
        console.log(err);
        store.dispatch(actions.setUsersError(true));
        setTimeout(() => store.dispatch(actions.setUsersError(false)), ERROR_TIMEOUT);
        return Promise.reject(err);
      });
  } else {
    return api.post('users/', data).then((res) => {
      store.dispatch(actions.insertUser(res.data));
      store.dispatch(actions.setUsersLoading(false));
      return res.data;
    });
  }
};

// PERMISSIONS

export const pullGroups = (data = {}) => {
  store.dispatch(actions.setGroupsLoading(true));
  store.dispatch(actions.setGroupsError(false));

  return api
    .get('groups/', data)
    .then((res) => {
      store.dispatch(actions.setGroups(res.data));
      store.dispatch(actions.setAdminStatus(res.data));
      store.dispatch(actions.setGroupsLoading(false));
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setGroupsError(true));
      setTimeout(() => store.dispatch(actions.setGroupsError(false)), ERROR_TIMEOUT);
    });
};

export const pullUserGroups = (data) => {
  store.dispatch(actions.setUserGroupsLoading(true));
  store.dispatch(actions.setUserGroupsError(false));

  return api
    .get('usergroups/', data)
    .then((res) => {
      store.dispatch(actions.setUserGroupsLoading(false));
      // individual editing user groups do not need to be shared across the app.
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setUserGroupsError(true));
      setTimeout(() => store.dispatch(actions.setUserGroupsError(false)), ERROR_TIMEOUT);
    });
};

// data required is group and user
export const createUserGroup = (data) => {
  store.dispatch(actions.setUserGroupsLoading(true));
  store.dispatch(actions.setUserGroupsError(false));

  return api
    .post('usergroups/', data)
    .then((res) => {
      store.dispatch(actions.setUserGroupsLoading(false));
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setUserGroupsError(true));
      setTimeout(() => store.dispatch(actions.setUserGroupsError(false)), ERROR_TIMEOUT);
    });
};

// data required is group and user
export const deleteUserGroup = (data) => {
  store.dispatch(actions.setUserGroupsLoading(true));
  store.dispatch(actions.setUserGroupsError(false));

  return api
    .delete(`usergroups/${data.group}?group=${data.group}&user=${data.user}`)
    .then((res) => {
      store.dispatch(actions.setUserGroupsLoading(false));
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setUserGroupsError(true));
      setTimeout(() => store.dispatch(actions.setUserGroupsError(false)), ERROR_TIMEOUT);
    });
};

//SITE ROUTES
export const pullSiteRoutes = (params) => {
  store.dispatch(actions.setSiteRoutesLoading(true));
  store.dispatch(actions.setSiteRoutesError(false));

  params = typeof params !== 'object' ? { sitecanvass: params } : params;

  return api
    .get('siteroutes/', params)
    .then((res) => {
      store.dispatch(actions.setSiteRoutesLoading(false));
      store.dispatch(actions.setSiteRoutes(res.data));
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setSiteRoutesError('We failed to load the siteroutes'));
      setTimeout(() => store.dispatch(actions.setSiteRoutesError(false)), ERROR_TIMEOUT);
    });
};

export const updateOrCreateSiteRoute = (data) => {
  store.dispatch(actions.setSiteRoutesLoading(true));
  store.dispatch(actions.setSiteRoutesError(false));

  if (Object.keys(data).includes('siteroute_id') || Object.keys(data).includes('id')) {
    let id = data.id || data.siteroute_id;
    return api
      .patch(`siteroutes/${id}/`, data)
      .then((res) => {
        console.log('RETURNED DATA', res.data);
        store.dispatch(actions.updateSiteRoute(res.data[0]));
        store.dispatch(actions.setSiteRoutesLoading(false));
      })
      .catch((err) => {
        console.log(err);
        store.dispatch(actions.setSiteRoutesError('Siteroute failed to update.'));
        setTimeout(() => store.dispatch(actions.setSiteRoutesError(false)), ERROR_TIMEOUT);
      });
  } else {
    return api
      .post('siteroutes/', data)
      .then((res) => {
        store.dispatch(actions.insertSiteRoute(res.data));
        store.dispatch(actions.setSiteRoutesLoading(false));
      })
      .catch((err) => {
        console.log(err);
        store.dispatch(actions.setSiteRoutesError('Siteroute failed to create.'));
        setTimeout(() => store.dispatch(actions.setSiteRoutesError(false)), ERROR_TIMEOUT);
      });
  }
};

export const removeSiteRoute = (data) => {
  store.dispatch(actions.setSiteRoutesLoading(true));
  store.dispatch(actions.setSiteRoutesError(false));

  if (Object.keys(data).includes('siteroute_id') || Object.keys(data).includes('id')) {
    let id = data.id || data.siteroute_id;
    return api
      .patch(`siteroutes/${id}/`, data)
      .then((res) => {
        store.dispatch(actions.removeSiteRoute(data));
        store.dispatch(actions.setSiteRoutesLoading(false));
      })
      .catch((err) => {
        console.log(err);
        store.dispatch(actions.setSiteRoutesError(true));
        setTimeout(() => store.dispatch(actions.setSiteRoutesError(false)), ERROR_TIMEOUT);
      });
  }
};

export const createRouteSeat = (data) => {
  store.dispatch(actions.setSiteRoutesLoading(true));
  store.dispatch(actions.setSiteRoutesError(false));

  return api
    .post('routeseats/', data)
    .then((res) => {
      store.dispatch(
        actions.insertRouteSeat({
          ...res.data,
          siteroute_id: data.siteroute,
          sites: [],
        })
      );
      store.dispatch(actions.setSiteRoutesLoading(false));
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setSiteRoutesError(true));
      store.dispatch(actions.setSiteRoutesLoading(false));
      setTimeout(() => store.dispatch(actions.setSiteRoutesError(false)), ERROR_TIMEOUT);
    });
};

export const deleteRouteSeat = (routeseat_id, siteroute_id) => {
  store.dispatch(actions.setSiteRoutesLoading(true));
  store.dispatch(actions.setSiteRoutesError(false));

  return api
    .delete(`routeseats/${routeseat_id}/`)
    .then((res) => {
      store.dispatch(actions.deleteRouteSeat({ siteroute_id, routeseat_id }));
      store.dispatch(actions.setSiteRoutesLoading(false));
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setSiteRoutesError(true));
      store.dispatch(actions.setSiteRoutesLoading(false));
      setTimeout(() => store.dispatch(actions.setSiteRoutesError(false)), ERROR_TIMEOUT);
    });
};

export const orderRouteSeatSites = (routeseat, siteroute) => {
  store.dispatch(actions.setSiteRoutesLoading(true));
  store.dispatch(actions.setSiteRoutesError(false));

  return api
    .get('/reorder-routeseatsites/', { routeseat })
    .then((res) => {
      if (res.data) {
        store.dispatch(
          actions.updateRouteSeatSiteOrder({
            sites: res.data,
            routeseat_id: routeseat,
            siteroute_id: siteroute,
          })
        );
        store.dispatch(actions.setSiteRoutesLoading(false));
        return res.data;
      }
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setSiteRoutesError(true));
      store.dispatch(actions.setSiteRoutesLoading(false));
      setTimeout(() => store.dispatch(actions.setSiteRoutesError(false)), ERROR_TIMEOUT);
    });
};

export const orderRouteSeats = (siteroute, sitecanvass) => {
  store.dispatch(actions.setSiteRoutesLoading(true));
  store.dispatch(actions.setSiteRoutesError(false));

  return api
    .get('/reorder-routeseats/', { siteroute, sitecanvass })
    .then((res) => {
      store.dispatch(
        actions.reorderRouteSeats({
          routeseats: res.data.seats,
          siteroute_id: siteroute,
        })
      );
      store.dispatch(actions.setSiteRoutesLoading(false));
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setSiteRoutesError(true));
      store.dispatch(actions.setSiteRoutesLoading(false));
      setTimeout(() => store.dispatch(actions.setSiteRoutesError(false)), ERROR_TIMEOUT);
    });
};

export const updateOrCreateRouteSeatSite = async (data) => {
  store.dispatch(actions.setSiteRoutesLoading(true));
  store.dispatch(actions.setSiteRoutesError(false));

  if (Object.keys(data).includes('routeseatsite_id') || Object.keys(data).includes('id')) {
    let id = data.id || data.routeseatsite_id;
    return await api
      .patch(`routeseatsites/${id}/`, data)
      .then((res) => {
        store.dispatch(actions.updateRouteSeatSite(res.data));
        store.dispatch(actions.setSiteRoutesLoading(false));
        return res.data;
      })
      .catch((err) => {
        console.log(err);
        store.dispatch(actions.setSiteRoutesError(true));
        setTimeout(() => store.dispatch(actions.setSiteRoutesError(false)), ERROR_TIMEOUT);
      });
  } else {
    return api
      .post('routeseatsites/', data)
      .then((res) => {
        store.dispatch(
          actions.insertRouteSeatSite({
            ...res.data,
            routeseat_id: data.routeseat,
            siteroute_id: data.siteroute,
          })
        );
        store.dispatch(actions.setSiteRoutesLoading(false));
        return res.data;
      })
      .catch((err) => {
        console.log(err);
        store.dispatch(actions.setSiteRoutesError(true));
        store.dispatch(actions.setSiteRoutesLoading(false));
        setTimeout(() => store.dispatch(actions.setSiteRoutesError(false)), ERROR_TIMEOUT);
      });
  }
};

export const deleteRouteSeatSite = (data) => {
  store.dispatch(actions.setSiteRoutesLoading(true));
  store.dispatch(actions.setSiteRoutesError(false));

  return api
    .delete(`routeseatsites/${data.routeseatsite_id}/`)
    .then((res) => {
      store.dispatch(actions.removeRouteSeatSite(data));
      store.dispatch(actions.setSiteRoutesLoading(false));
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setSiteRoutesError(true));
      store.dispatch(actions.setSiteRoutesLoading(false));
      setTimeout(() => store.dispatch(actions.setSiteRoutesError(false)), ERROR_TIMEOUT);
    });
};

//SCRIPTS
export const pullCampaignScripts = () => {
  store.dispatch(actions.setCampaignScriptsLoading(true));
  store.dispatch(actions.setCampaignScriptsError(false));

  return api
    .get('scripts/', {})
    .then((res) => {
      store.dispatch(actions.setCampaignScriptsLoading(false));
      store.dispatch(actions.setCampaignScripts(res.data));
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setCampaignScriptsError(true));
      setTimeout(() => store.dispatch(actions.setCampaignScriptsError(false)), ERROR_TIMEOUT);
    });
};

//currently, scripts have limited functionality, Mostly we need them so we know how to assign a new sitecanvass
//this function is not called and will need to be updated.
export const updateOrCreateScript = (data) => {
  store.dispatch(actions.setCampaignScriptsLoading(true));
  store.dispatch(actions.setCampaignScriptsError(false));

  if (Object.keys(data).includes('id')) {
    return api
      .patch(`scripts/${data.id}/`, data)
      .then((res) => {
        store.dispatch(actions.updateScript(res.data));
        store.dispatch(actions.setCampaignScriptsLoading(false));
      })
      .catch((err) => {
        console.log(err);
        store.dispatch(actions.setCampaignScriptsError(true));
        setTimeout(() => store.dispatch(actions.setCampaignScriptsError(false)), ERROR_TIMEOUT);
      });
  } else {
    return api.post('scripts/', data).then((res) => {
      store.dispatch(actions.insertScript(res.data));
      store.dispatch(actions.setCampaignScriptsLoading(false));
    });
  }
};

// Shifts

export const getSchedule = (office, date) => {
  return api
    .get('/shifts/', { office, date })
    .then((res) => {
      let data = res.data;
      let time_string_format = 'HH:mm:ss';
      return data.sort((a, b) => {
        return moment(a.start_time, time_string_format) > moment(b.start_time, time_string_format)
          ? 1
          : -1;
      });
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// office, start, end, date
export const createShift = (data) => {
  return api
    .post('wox-shift/', data)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return;
    });
};

///RESPONSE AGGREGATES

export const pullCampaignResponseAggregates = (params) => {
  store.dispatch(actions.setResponseAggregateLoading(true));
  store.dispatch(actions.setResponseAggregateError(false));

  return api
    .get('response-aggregates/', params)
    .then((res) => {
      store.dispatch(actions.setResponseAggregateLoading(false));
      store.dispatch(actions.setResponseAggregateData(res.data));
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setResponseAggregateError(true));
      setTimeout(() => store.dispatch(actions.setResponseAggregateError(false)), ERROR_TIMEOUT);
    });
};

// assigned sites and turfs

export const pullAssignedSites = (params) => {
  store.dispatch(actions.setAssignedSitesLoading(true));
  store.dispatch(actions.setAssignedSitesError(false));
  store.dispatch(actions.setAssignedSitesCallParams(params));

  return api
    .get('assigned-sites/', params)
    .then((res) => {
      store.dispatch(actions.setAssignedSitesLoading(false));
      store.dispatch(actions.setAssignedSites(res.data));
      return res.data;
    })
    .catch((err) => {
      console.error(err);
      store.dispatch(actions.setAssignedSitesError(true));
      setTimeout(() => store.dispatch(actions.setAssignedSitesError(false)), ERROR_TIMEOUT);
    });
};

export const pullAssignedTurfs = (params) => {
  store.dispatch(actions.setAssignedTurfsLoading(true));
  store.dispatch(actions.setAssignedTurfsError(false));
  store.dispatch(actions.setAssignedTurfsCallParams(params));

  return api
    .get('assigned-turfs/', params)
    .then((res) => {
      store.dispatch(actions.setAssignedTurfsLoading(false));
      store.dispatch(actions.setAssignedTurfs(res.data));
      return res.data;
    })
    .catch((err) => {
      console.error(err);
      store.dispatch(actions.setAssignedTurfsError(true));
      setTimeout(() => store.dispatch(actions.setAssignedTurfsError(false)), ERROR_TIMEOUT);
    });
};

//LOGOUT
export const logout = () => {
  store.dispatch(actions.setAccessToken(null));
  store.dispatch(actions.setRefreshToken(null));
};

export const pullSiteNoteCategories = () => {
  store.dispatch(actions.setSiteNotesLoading(true));
  store.dispatch(actions.setSiteNotesError(false));

  return api
    .get('note-categories/')
    .then((res) => {
      console.log('categories', res.data);
      store.dispatch(actions.setSiteNoteCategories(res.data));
      store.dispatch(actions.setSiteNotesLoading(false));
    })
    .catch(() => {
      store.dispatch(actions.setSiteNotesError(true));
      setTimeout(() => store.dispatch(actions.setSiteNotesError(false)), ERROR_TIMEOUT);
      store.dispatch(actions.setSiteNotesLoading(false));
    });
};

export const pullSiteNotes = () => {
  store.dispatch(actions.setSiteNotesLoading(true));
  store.dispatch(actions.setSiteNotesError(false));

  api
    .get('sitenotes/')
    .then((res) => {
      store.dispatch(actions.setSiteNotes(res.data));
      store.dispatch(actions.setSiteNotesLoading(false));
    })
    .catch(() => {
      store.dispatch(actions.setSiteNotesError(true));
      setTimeout(() => store.dispatch(actions.setSiteNotesError(false)), ERROR_TIMEOUT);
      store.dispatch(actions.setSiteNotesLoading(false));
    });
};

export const createSiteNote = (data) => {
  store.dispatch(actions.setSiteNotesLoading(true));
  store.dispatch(actions.setSiteNotesError(false));

  return api
    .post('/sitenotes/', data)
    .then((res) => {
      let state = store.getState();
      let r_data = { ...res.data };
      // now update the notes in the site in redux

      let targetSite = state.sites.data.find((d) => d.id === r_data.site_id);
      if (!targetSite) {
        console.error('Unable to update site... failure to find. Site ID:', r_data.site_id);
      }

      targetSite = {
        ...targetSite,
        notes: [...(targetSite.notes || []), r_data],
      };
      store.dispatch(actions.updateSite(targetSite));

      store.dispatch(actions.setSiteNotesLoading(false));
      return r_data;
    })
    .catch((e) => {
      console.log('CAUGHT A SITENOTE CREATE ERROR');
      store.dispatch(actions.setSiteNotesError('Note failed to create'));
      console.error(e);
      setTimeout(() => store.dispatch(actions.setSiteNotesError(false)), ERROR_TIMEOUT);
      store.dispatch(actions.setSiteNotesLoading(false));
      throw e;
    });
};

// you're editing SITENOTE, NOT NOTE HERE.
export const removeSiteNote = (sitenote_id) => {
  store.dispatch(actions.setSiteNotesLoading(true));
  store.dispatch(actions.setSiteNotesError(false));
  api
    .patch(`sitenotes/${sitenote_id}/`, { is_active: false })
    .then((res) => {
      let state = store.getState();
      let targetSite = state.sites.data.find((d) => d.id === res.data.site);
      if (!targetSite) {
        console.error('Unable to update site... failure to find. Site ID:', res.data.site);
      }

      targetSite = {
        ...targetSite,
        notes: (targetSite.notes || []).filter((d) => d.id !== sitenote_id),
      };

      store.dispatch(actions.updateSite(targetSite));

      store.dispatch(actions.setSiteNotesLoading(false));
    })
    .catch((e) => {
      store.dispatch(actions.setSiteNotesError('Note failed to delete'));
      console.error(e);
      setTimeout(() => store.dispatch(actions.setSiteNotesError(false)), ERROR_TIMEOUT);
      store.dispatch(actions.setSiteNotesLoading(false));
    });
};

//ALERTS
//campaign automatically added at exit, so not needed here as a param
export const pullCampaignWebhooks = () => {
  store.dispatch(actions.setAlertConfigsLoading(true));
  store.dispatch(actions.setAlertConfigsError(false));

  return api
    .get('webhooks/')
    .then((res) => {
      store.dispatch(actions.setAlertWebhooks(res.data));
      store.dispatch(actions.setAlertConfigsLoading(false));
      return res.data;
    })
    .catch((e) => {
      store.dispatch(actions.setAlertConfigsError('Webhooks failed to load'));
      console.error(e);
      setTimeout(() => store.dispatch(actions.setAlertConfigsError(false)), ERROR_TIMEOUT);
      store.dispatch(actions.setAlertConfigsLoading(false));
    });
};

export const updateOrCreateWebhook = (data) => {
  store.dispatch(actions.setAlertConfigsLoading(true));
  store.dispatch(actions.setAlertConfigsError(false));

  if (data.id) {
    return api
      .patch(`webhooks/${data.id}/`, { ...data })
      .then((res) => {
        store.dispatch(actions.updateAlertWebhook(res.data));
        store.dispatch(actions.setAlertConfigsLoading(false));
        return res.data;
      })
      .catch((e) => {
        store.dispatch(actions.setAlertConfigsError('Webhook failed to update'));
        console.error(e);
        setTimeout(() => store.dispatch(actions.setAlertConfigsError(false)), ERROR_TIMEOUT);
        store.dispatch(actions.setAlertConfigsLoading(false));
      });
  } else {
    return api
      .post(`webhooks/`, { ...data })
      .then((res) => {
        store.dispatch(actions.addAlertWebhook(res.data));
        store.dispatch(actions.setAlertConfigsLoading(false));
        return res.data;
      })
      .catch((e) => {
        store.dispatch(actions.setAlertConfigsError('Webhook failed to create'));
        console.error(e);
        setTimeout(() => store.dispatch(actions.setAlertConfigsError(false)), ERROR_TIMEOUT);
        store.dispatch(actions.setAlertConfigsLoading(false));
      });
  }
};

// must pass sitecanvass or doorcanvass param with id
export const pullCanvassAlertConfigs = (sitecanvass, doorcanvass) => {
  store.dispatch(actions.setAlertConfigsLoading(true));
  store.dispatch(actions.setAlertConfigsError(false));

  return api
    .get('alert-configs/', { sitecanvass, doorcanvass })
    .then((res) => {
      store.dispatch(actions.setAlertConfigs(res.data));
      store.dispatch(actions.setAlertConfigsLoading(false));
      return res.data;
    })
    .catch((e) => {
      store.dispatch(actions.setAlertConfigsError('Alert configurations failed to load'));
      console.error(e);
      setTimeout(() => store.dispatch(actions.setAlertConfigsError(false)), ERROR_TIMEOUT);
      store.dispatch(actions.setAlertConfigsLoading(false));
    });
};

export const updateOrCreateAlertConfig = (data) => {
  store.dispatch(actions.setAlertConfigsLoading(true));
  store.dispatch(actions.setAlertConfigsError(false));

  if (data.id) {
    return api
      .patch(`alert-configs/${data.id}/`, { ...data })
      .then((res) => {
        store.dispatch(actions.updateAlertConfig(res.data));
        store.dispatch(actions.setAlertConfigsLoading(false));
        return res.data;
      })
      .catch((e) => {
        store.dispatch(actions.setAlertConfigsError('Alert configuration failed to update'));
        console.error(e);
        setTimeout(() => store.dispatch(actions.setAlertConfigsError(false)), ERROR_TIMEOUT);
        store.dispatch(actions.setAlertConfigsLoading(false));
      });
  } else {
    return api
      .post(`alert-configs/`, { ...data })
      .then((res) => {
        store.dispatch(actions.addAlertConfig({ ...res.data, webhooks: data.webhooks }));
        store.dispatch(actions.setAlertConfigsLoading(false));
        return res.data;
      })
      .catch((e) => {
        store.dispatch(actions.setAlertConfigsError('Webhook failed to create'));
        console.error(e);
        setTimeout(() => store.dispatch(actions.setAlertConfigsError(false)), ERROR_TIMEOUT);
        store.dispatch(actions.setAlertConfigsLoading(false));
      });
  }
};

// must pass sitecanvass or doorcanvass param with id
export const removeCanvassAlertConfig = (data) => {
  store.dispatch(actions.setAlertConfigsLoading(true));
  store.dispatch(actions.setAlertConfigsError(false));

  return api
    .delete(`alert-configs/${data.id}`)
    .then((res) => {
      store.dispatch(actions.removeAlertConfig(data));
      store.dispatch(actions.setAlertConfigsLoading(false));
      return res.data;
    })
    .catch((e) => {
      store.dispatch(actions.setAlertConfigsError('Alert configuration failed to delete.'));
      console.error(e);
      setTimeout(() => store.dispatch(actions.setAlertConfigsError(false)), ERROR_TIMEOUT);
      store.dispatch(actions.setAlertConfigsLoading(false));
    });
};

// must contain {webhook, alertconfig}
export const updateOrCreateAlertConfigWebhook = (data) => {
  store.dispatch(actions.setAlertConfigsLoading(true));
  store.dispatch(actions.setAlertConfigsError(false));

  let promise;
  if (data.id) {
    promise = api.patch(`alert-config-webhooks/${data.id}/`, data).then((res) => {
      store.dispatch(actions.updateAlertConfigWebhook(res.data));
      store.dispatch(actions.setAlertConfigsLoading(false));
      return res.data;
    });
  } else {
    promise = api.post(`alert-config-webhooks/`, data).then((res) => {
      console.log('inbound', res.data);
      store.dispatch(actions.addAlertConfigWebhook(res.data));
      console.log('new webhook added');
      store.dispatch(actions.setAlertConfigsLoading(false));
      return res.data;
    });
  }

  return promise.catch((e) => {
    store.dispatch(actions.setAlertConfigsError('Webook failed to attach to alert configuration.'));
    console.error(e);
    setTimeout(() => store.dispatch(actions.setAlertConfigsError(false)), ERROR_TIMEOUT);
    store.dispatch(actions.setAlertConfigsLoading(false));
    return { error: true };
  });
};

// must contain {id, webhook, alertconfig}
export const removeAlertConfigWebhook = (data) => {
  store.dispatch(actions.setAlertConfigsLoading(true));
  store.dispatch(actions.setAlertConfigsError(false));

  return api
    .delete(`alert-config-webhooks/${data.id}`)
    .then((res) => {
      store.dispatch(actions.removeAlertConfigWebhook(data));
      store.dispatch(actions.setAlertConfigsLoading(false));
      return res.data;
    })
    .catch((e) => {
      store.dispatch(
        actions.setAlertConfigsError('Webook failed to attach to alert configuration.')
      );
      console.error(e);
      setTimeout(() => store.dispatch(actions.setAlertConfigsError(false)), ERROR_TIMEOUT);
      store.dispatch(actions.setAlertConfigsLoading(false));
    });
};

//DOOR CANVASSES

export const pullCampaignDoorCanvasses = doors.pullCampaignDoorCanvasses;
export const pullCampaignDoorCanvassPasses = doors.pullCampaignDoorCanvassPasses;
